import { useState } from 'react'
import { Modal, Placeholder } from '@telegram-apps/telegram-ui'
import cn from 'classnames'

import { Calendar, CalendarIcon, Input } from 'components'
import { formatDateToISO, formatISOToInputDate } from 'utils'

import './styles.scss'

export interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'onChange'> {
  value: string
  onChange: (value: string) => void
  onModalOpened?: (state: boolean) => void
  scrollToOnFocus?: boolean
}

export const DatePicker = (props: Props) => {
  const { value, label, className, onChange, onModalOpened, ...rest } = props
  const [open, setOpen] = useState(false)

  const onChangeHandler = (value: string) => {
    onChange?.(value)
    setOpen(false)
  }

  const onOpenModal = (state: boolean) => {
    setOpen(state)
    onModalOpened?.(state)
  }

  const baseJsx = (
    <>
      <Input
        mask="99.99.9999"
        value={value}
        onChange={onChange}
        className={cn('form-input date-picker-input', className)}
        inputMode="numeric"
        {...rest}
      />
      <CalendarIcon
        className="date-picker-icon"
        width={16}
        height={16}
        onClick={() => setOpen(true)}
      />
    </>
  )

  return (
    <div className="date-picker">
      <Modal className="picker-modal" open={open} onOpenChange={onOpenModal} dismissible>
        <Placeholder>
          <Calendar
            value={formatDateToISO(value)}
            onChange={(value: string) => onChangeHandler(formatISOToInputDate(value))}
          />
        </Placeholder>
      </Modal>

      {label ? (
        <label className="form-label">
          <span className="input-label">{label}</span>
          <div className="label-inner">{baseJsx}</div>
        </label>
      ) : (
        baseJsx
      )}
    </div>
  )
}
